import { useQuery } from "react-query";

import http from "../../services/httpService";
import Util from "../../util/util";
import useLeague from "../queryResults/useLeague";
import useLeagueSeason from "../queryResults/useLeagueSeason";
import useUrls from "../useUrls";

/**
 *
 * @param {League} league
 * @param {LeagueSeason} leagueSeason
 * @param {string} apiUrl
 * @returns {function(): Promise<*>}
 */
const getTeams = (league, leagueSeason, apiUrl) => async () => {
  console.log("getTeams() called...");

  const config = Util.addTokenToHeaders();
  const { data } = await http.get(
    `${apiUrl}/leagues/${league.getIdOrSlug()}/${
      leagueSeason.obj.season
    }/teams`,
    config
  );

  console.log("getTeams() response data:");
  console.log(data);

  return data;
};

export default function useQueryTeams() {
  const { league } = useLeague();
  const { leagueSeason } = useLeagueSeason();
  const { apiUrl } = useUrls();

  return useQuery(
    ["teams", leagueSeason?.obj?.id],
    getTeams(league, leagueSeason, apiUrl),
    {
      enabled: !!league && !!leagueSeason,
      refetchOnWindowFocus: false,
      staleTime: 2 * 60 * 60 * 1000,
    }
  );
}
